import { render, staticRenderFns } from "./SidebarContact.vue?vue&type=template&id=c4aa993a&"
import script from "./SidebarContact.vue?vue&type=script&lang=js&"
export * from "./SidebarContact.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports